import { render, staticRenderFns } from "./EnacAtplDashboardItemTopBox.vue?vue&type=template&id=36ff1145"
import script from "./EnacAtplDashboardItemTopBox.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardItemTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports